module.exports = __webpack_public_path__ + "ed12d969adad03529d649d7e1591e566.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/suppliers/1.png
// module id = 537
// module chunks = 21 54 55 56 77 79 80 88